import React from 'react';
import { useInView } from '@/hooks/useInView';

export function Reveal({ as: As = 'div', delay = 0, className = '', children, ...rest }) {
  const [ref, inView] = useInView();
  return (
    <As
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal-blur ${inView ? 'in-view' : ''} ${className}`}
      {...rest}
    >
      {children}
    </As>
  );
}

export function RevealStagger({ children, gap = 90, className = '' }) {
  const arr = React.Children.toArray(children);
  return (
    <div className={className}>
      {arr.map((child, i) => (
        <Reveal key={i} delay={i * gap}>{child}</Reveal>
      ))}
    </div>
  );
}
